import reducer, { actions, MiscellaneousKeys, MiscellaneousState } from './miscellaneous.reducer';

export default reducer;
export { actions };
export type { MiscellaneousKeys, MiscellaneousState };
